import { Component, HostListener, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AppMaterialModule } from '../../../app-material.module';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

export interface ConfirmDialogInputData {
    titulo?: string;
    descricao?: string;
    valorBase?: string;
}

@Component({
    selector: 'app-confirm-dialog-input',
    standalone: true,
    imports: [AppMaterialModule, TranslocoPipe],
    templateUrl: './confirm-dialog-input.component.html',
    styleUrl: './confirm-dialog-input.component.scss',
})
export class ConfirmDialogInputComponent {
    public titulo = '';
    public descricao = '';
    public valorBase = '';
    public textoConfirmacao = '';

    private readonly transloco = inject(TranslocoService);
    private readonly toastr = inject(ToastrService);

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogInputData,
        private dialogRef: MatDialogRef<ConfirmDialogInputComponent>,
    ) {
        this.titulo = this.resolveText(data.titulo, 'shared.confirmDialogInput.defaultTitle');
        this.descricao = this.resolveText(data.descricao, 'shared.confirmDialogInput.defaultDescription');
        this.valorBase = (data.valorBase ?? '').trim();
    }

    get isConfirmationValid(): boolean {
        return this.textoConfirmacao.trim().toLowerCase() === this.valorBase.toLowerCase();
    }

    sim(): void {
        if (this.valorBase && !this.isConfirmationValid) {
            return;
        }
        this.dialogRef.close(true);
    }

    copiar(): void {
        this.toastr.success(this.transloco.translate('shared.confirmDialogInput.copySuccess'));
    }

    nao(): void {
        this.dialogRef.close(false);
    }

    fechar(): void {
        this.dialogRef.close();
    }

    @HostListener('document:keydown.enter', ['$event'])
    onEnterKey(event: KeyboardEvent): void {
        event.preventDefault();
        this.sim();
    }

    private resolveText(value: string | undefined, fallbackKey?: string): string {
        if (!value) {
            return fallbackKey ? this.transloco.translate(fallbackKey) : '';
        }

        if (value.includes('.') && !/\s/.test(value)) {
            return this.transloco.translate(value);
        }

        return value;
    }
}
